import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { usePayment } from "../../hooks/usePayment";
import { CheckoutFormBillingInfoFields } from "../CheckoutFormBillingInfoFields";
import { PaymentMethodTypeForm } from "../PaymentMethodTypeForm";

export const ElementsWithoutPMC = () => {
  const { currentCommunityProcessorPaymentMethodConfigurationId } =
    usePaywallCheckoutContext();

  const { handleOnChangeCard, handleOnReadyCard } = usePayment();

  if (currentCommunityProcessorPaymentMethodConfigurationId) {
    return null;
  }

  return (
    <>
      <PaymentMethodTypeForm
        handleOnReadyCard={handleOnReadyCard}
        handleOnChangeCard={handleOnChangeCard}
      />
      <CheckoutFormBillingInfoFields />
    </>
  );
};
